import getCurrentLayout from "tenants/get-current-layout"
import getUrlToLayout from "shared/get-url-to-layout"

export default async function getPathToLayout(layout, pathName, ...args) {
  const currentLayout = getCurrentLayout()
  const fullPathName = `${pathName}Path`

  // Competition screens are shared with the Nemoa layout and historically
  // redirect to "nemoa" explicitly. Keep competition routes on the isolated
  // domain, while still allowing redirects to Nemoa-only routes.
  const useCompetitionLayout = currentLayout === "competition" && layout === "nemoa" && CompetitionRoutes[fullPathName]
  const effectiveLayout = useCompetitionLayout ? "competition" : layout

  let routes

  if (effectiveLayout === "admin") {
    routes = AdminRoutes
  } else if (effectiveLayout === "competition") {
    routes = CompetitionRoutes
  } else if (effectiveLayout === "nemoa") {
    routes = NemoaRoutes
  } else if (effectiveLayout === "merfoto") {
    routes = MerfotoRoutes
  } else {
    throw new Error(`Unknown layout: ${effectiveLayout}`)
  }

  if (!routes[fullPathName]) {
    throw new Error(`No such route on the ${effectiveLayout} layout: ${fullPathName}`)
  }

  if (currentLayout === effectiveLayout) {
    return routes[fullPathName](...args)
  }

  const url = await getUrlToLayout(effectiveLayout, pathName, ...args)

  return url
}
